import {
  SamsChallengeOutcome,
  ScoreHistory,
  ScoreHistoryEntry,
} from "@/models/gameState";
import { Score, TeamReference } from "@/models/pdfData";
import { DeepReadonly } from "@/models/utils";
import {
  UpdateAction,
  UpdateActionType,
  UpdateActionWithState,
} from "@/models/socketIo/updateAction";
import { otherTeam } from "@/pdf/utils";
import { getScoringTeamFromChallenge } from "@/utils/challenge-utils";

export const getScoreFromHistory = (
  scoreHistory: DeepReadonly<ScoreHistory>,
  scoreIndex: number,
): ScoreHistoryEntry => {
  const allScores = Object.entries(scoreHistory).flatMap(
    ([setNumber, setScores]) =>
      setScores.map(
        (scoreHistoryEntry) =>
          ({
            setNumber: parseInt(setNumber),
            score: {
              team1: scoreHistoryEntry[1],
              team2: scoreHistoryEntry[2],
            } as Score,
          }) as ScoreHistoryEntry,
      ),
  );

  if (scoreIndex >= 0) {
    return allScores[scoreIndex];
  } else {
    return allScores[allScores.length + scoreIndex];
  }
};

export const isScoringAction = (
  action?: UpdateAction | UpdateActionWithState,
) =>
  action &&
  ((
    [
      "[Set] Score",
      "[Sanction] Individual Penalty",
      "[Sanction] Team Penalty",
    ] as UpdateActionType[]
  ).includes(action.type) ||
    (action.type === "[Challenges] Challenge success" &&
      (
        ["POINT_TEAM1", "POINT_TEAM2", "CONFIRMED"] as SamsChallengeOutcome[]
      ).includes(action.payload.outcome)));

export const teamScoredInAction = (
  action?: UpdateActionWithState | UpdateAction,
  team?: TeamReference,
) => {
  if (!action || !team) {
    return false;
  }
  return getScoringTeamFromAction(action) === team;
};

export const getScoringTeamFromAction = (
  action?: UpdateActionWithState | UpdateAction,
): TeamReference | undefined => {
  if (!action) {
    return undefined;
  }
  switch (action.type) {
    case "[Set] Score":
      return action.payload;
    case "[Sanction] Individual Penalty":
    case "[Sanction] Team Penalty":
      return otherTeam(action.payload.teamCode);
    case "[Challenges] Challenge success":
      return getScoringTeamFromChallenge(action.payload);
    default:
      return undefined;
  }
};
